// @generated by protoc-gen-es v1.10.0 with parameter "target=ts"
// @generated from file penumbra/cnidarium/v1/cnidarium.proto (package penumbra.cnidarium.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
import { Message, proto3, protoInt64 } from "@bufbuild/protobuf";
import { MerkleProof } from "../../../ibc/core/commitment/v1/commitment_pb.js";
/**
 * Performs a key-value query against the nonverifiable storage,
 * using a byte-encoded key.
 *
 * @generated from message penumbra.cnidarium.v1.NonVerifiableKeyValueRequest
 */
export class NonVerifiableKeyValueRequest extends Message {
    /**
     * @generated from field: penumbra.cnidarium.v1.NonVerifiableKeyValueRequest.Key key = 1;
     */
    key;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.cnidarium.v1.NonVerifiableKeyValueRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "key", kind: "message", T: NonVerifiableKeyValueRequest_Key },
    ]);
    static fromBinary(bytes, options) {
        return new NonVerifiableKeyValueRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new NonVerifiableKeyValueRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new NonVerifiableKeyValueRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(NonVerifiableKeyValueRequest, a, b);
    }
}
/**
 * @generated from message penumbra.cnidarium.v1.NonVerifiableKeyValueRequest.Key
 */
export class NonVerifiableKeyValueRequest_Key extends Message {
    /**
     * @generated from field: bytes inner = 1;
     */
    inner = new Uint8Array(0);
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.cnidarium.v1.NonVerifiableKeyValueRequest.Key";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "inner", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    ]);
    static fromBinary(bytes, options) {
        return new NonVerifiableKeyValueRequest_Key().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new NonVerifiableKeyValueRequest_Key().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new NonVerifiableKeyValueRequest_Key().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(NonVerifiableKeyValueRequest_Key, a, b);
    }
}
/**
 * @generated from message penumbra.cnidarium.v1.NonVerifiableKeyValueResponse
 */
export class NonVerifiableKeyValueResponse extends Message {
    /**
     * The value corresponding to the specified key, if it was found.
     *
     * @generated from field: penumbra.cnidarium.v1.NonVerifiableKeyValueResponse.Value value = 1;
     */
    value;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.cnidarium.v1.NonVerifiableKeyValueResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "value", kind: "message", T: NonVerifiableKeyValueResponse_Value },
    ]);
    static fromBinary(bytes, options) {
        return new NonVerifiableKeyValueResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new NonVerifiableKeyValueResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new NonVerifiableKeyValueResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(NonVerifiableKeyValueResponse, a, b);
    }
}
/**
 * @generated from message penumbra.cnidarium.v1.NonVerifiableKeyValueResponse.Value
 */
export class NonVerifiableKeyValueResponse_Value extends Message {
    /**
     * @generated from field: bytes value = 1;
     */
    value = new Uint8Array(0);
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.cnidarium.v1.NonVerifiableKeyValueResponse.Value";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "value", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    ]);
    static fromBinary(bytes, options) {
        return new NonVerifiableKeyValueResponse_Value().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new NonVerifiableKeyValueResponse_Value().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new NonVerifiableKeyValueResponse_Value().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(NonVerifiableKeyValueResponse_Value, a, b);
    }
}
/**
 * Performs a key-value query against the JMT, either by key or by key hash.
 *
 * Proofs are only supported by key.
 *
 * @generated from message penumbra.cnidarium.v1.KeyValueRequest
 */
export class KeyValueRequest extends Message {
    /**
     * If set, the key to fetch from storage.
     *
     * @generated from field: string key = 2;
     */
    key = "";
    /**
     * whether to return a proof
     *
     * @generated from field: bool proof = 3;
     */
    proof = false;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.cnidarium.v1.KeyValueRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 2, name: "key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 3, name: "proof", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    ]);
    static fromBinary(bytes, options) {
        return new KeyValueRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new KeyValueRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new KeyValueRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(KeyValueRequest, a, b);
    }
}
/**
 * @generated from message penumbra.cnidarium.v1.KeyValueResponse
 */
export class KeyValueResponse extends Message {
    /**
     * The value corresponding to the specified key, if it was found.
     *
     * @generated from field: penumbra.cnidarium.v1.KeyValueResponse.Value value = 1;
     */
    value;
    /**
     * A proof of existence or non-existence.
     *
     * @generated from field: ibc.core.commitment.v1.MerkleProof proof = 2;
     */
    proof;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.cnidarium.v1.KeyValueResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "value", kind: "message", T: KeyValueResponse_Value },
        { no: 2, name: "proof", kind: "message", T: MerkleProof },
    ]);
    static fromBinary(bytes, options) {
        return new KeyValueResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new KeyValueResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new KeyValueResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(KeyValueResponse, a, b);
    }
}
/**
 * @generated from message penumbra.cnidarium.v1.KeyValueResponse.Value
 */
export class KeyValueResponse_Value extends Message {
    /**
     * @generated from field: bytes value = 1;
     */
    value = new Uint8Array(0);
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.cnidarium.v1.KeyValueResponse.Value";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "value", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    ]);
    static fromBinary(bytes, options) {
        return new KeyValueResponse_Value().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new KeyValueResponse_Value().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new KeyValueResponse_Value().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(KeyValueResponse_Value, a, b);
    }
}
/**
 * Performs a prefixed key-value query, by string prefix.
 *
 * @generated from message penumbra.cnidarium.v1.PrefixValueRequest
 */
export class PrefixValueRequest extends Message {
    /**
     * The prefix to fetch subkeys from storage.
     *
     * @generated from field: string prefix = 2;
     */
    prefix = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.cnidarium.v1.PrefixValueRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 2, name: "prefix", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new PrefixValueRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PrefixValueRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PrefixValueRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PrefixValueRequest, a, b);
    }
}
/**
 * @generated from message penumbra.cnidarium.v1.PrefixValueResponse
 */
export class PrefixValueResponse extends Message {
    /**
     * @generated from field: string key = 1;
     */
    key = "";
    /**
     * @generated from field: bytes value = 2;
     */
    value = new Uint8Array(0);
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.cnidarium.v1.PrefixValueResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "value", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    ]);
    static fromBinary(bytes, options) {
        return new PrefixValueResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PrefixValueResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PrefixValueResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PrefixValueResponse, a, b);
    }
}
/**
 * Requests a stream of new key-value pairs that have been committed to the state.
 *
 * @generated from message penumbra.cnidarium.v1.WatchRequest
 */
export class WatchRequest extends Message {
    /**
     * A regex for keys in the verifiable storage.
     *
     * Only key-value updates whose keys match this regex will be returned.
     * Note that the empty string matches all keys.
     * To exclude all keys, use the regex "$^", which matches no strings.
     *
     * @generated from field: string key_regex = 1;
     */
    keyRegex = "";
    /**
     * A regex for keys in the nonverifiable storage.
     *
     * Only key-value updates whose keys match this regex will be returned.
     * Note that the empty string matches all keys.
     * To exclude all keys, use the regex "$^", which matches no strings.
     *
     * @generated from field: string nv_key_regex = 2;
     */
    nvKeyRegex = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.cnidarium.v1.WatchRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "key_regex", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "nv_key_regex", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new WatchRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new WatchRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new WatchRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(WatchRequest, a, b);
    }
}
/**
 * A key-value pair that has been committed to the state.
 *
 * @generated from message penumbra.cnidarium.v1.WatchResponse
 */
export class WatchResponse extends Message {
    /**
     * The state version the key-value pair was committed at.
     *
     * @generated from field: uint64 version = 1;
     */
    version = protoInt64.zero;
    /**
     * The entry that was committed.
     *
     * @generated from oneof penumbra.cnidarium.v1.WatchResponse.entry
     */
    entry = { case: undefined };
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.cnidarium.v1.WatchResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "version", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
        { no: 5, name: "kv", kind: "message", T: WatchResponse_KeyValue, oneof: "entry" },
        { no: 6, name: "nv_kv", kind: "message", T: WatchResponse_NvKeyValue, oneof: "entry" },
    ]);
    static fromBinary(bytes, options) {
        return new WatchResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new WatchResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new WatchResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(WatchResponse, a, b);
    }
}
/**
 * Elements of the verifiable storage have string keys.
 *
 * @generated from message penumbra.cnidarium.v1.WatchResponse.KeyValue
 */
export class WatchResponse_KeyValue extends Message {
    /**
     * @generated from field: string key = 1;
     */
    key = "";
    /**
     * @generated from field: bytes value = 2;
     */
    value = new Uint8Array(0);
    /**
     * If set to true, the key-value pair was deleted.
     * This allows distinguishing a deleted key-value pair from a key-value pair whose value is empty.
     *
     * @generated from field: bool deleted = 3;
     */
    deleted = false;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.cnidarium.v1.WatchResponse.KeyValue";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "value", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
        { no: 3, name: "deleted", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    ]);
    static fromBinary(bytes, options) {
        return new WatchResponse_KeyValue().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new WatchResponse_KeyValue().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new WatchResponse_KeyValue().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(WatchResponse_KeyValue, a, b);
    }
}
/**
 * Elements of the nonverifiable storage have byte keys.
 *
 * @generated from message penumbra.cnidarium.v1.WatchResponse.NvKeyValue
 */
export class WatchResponse_NvKeyValue extends Message {
    /**
     * @generated from field: bytes key = 1;
     */
    key = new Uint8Array(0);
    /**
     * @generated from field: bytes value = 2;
     */
    value = new Uint8Array(0);
    /**
     * If set to true, the key-value pair was deleted.
     * This allows distinguishing a deleted key-value pair from a key-value pair whose value is empty.
     *
     * @generated from field: bool deleted = 3;
     */
    deleted = false;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.cnidarium.v1.WatchResponse.NvKeyValue";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "key", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
        { no: 2, name: "value", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
        { no: 3, name: "deleted", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    ]);
    static fromBinary(bytes, options) {
        return new WatchResponse_NvKeyValue().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new WatchResponse_NvKeyValue().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new WatchResponse_NvKeyValue().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(WatchResponse_NvKeyValue, a, b);
    }
}
